"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var logos_1 = __importDefault(require("./logos"));

var tokens_json_1 = __importDefault(require("./tokens.json"));

var mainnetTokens = [{
  address: '0xA55F26319462355474A9F2c8790860776a329aA4',
  ethereum: '0x1416946162B1C2c871A73B07E932D2fB6C932069',
  logo: logos_1["default"].WNRGLogo
}, {
  address: '0x0ee5893f434017d8881750101Ea2F7c49c0eb503',
  ethereum: '0x6b175474e89094c44da98b954eedeac495271d0f',
  logo: logos_1["default"].DAILogo
}, {
  address: '0x78B050d981d7f6E019Bf6E361D0d1167de6B19dA',
  ethereum: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  logo: logos_1["default"].ETHLogo
}, {
  address: '0x29a791703e5A5A8D1578F8611b4D3691377CEbc0',
  ethereum: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
  logo: logos_1["default"].BTCLogo
}, {
  address: '0x665B3A802979eC24e076c80025bFF33c18eB6007',
  ethereum: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
  logo: logos_1["default"].UNILogo
}, {
  address: '0xA7F2f790355E0C32CAb03f92F6EB7f488E6F049a',
  ethereum: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
  logo: logos_1["default"].AAVELogo
}, {
  address: '0x68Ca48cA2626c415A89756471D4ADe2CC9034008',
  ethereum: '0x514910771af9ca656af840dff83e8264ecf986ca',
  logo: logos_1["default"].LINKLogo
}, {
  address: '0xa255461fF545d6ecE153283f421D67D2DE5D0E29',
  ethereum: '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
  logo: logos_1["default"].SNXLogo
}, {
  address: '0x2726Dd5efb3A209a54C512e9562A2045B8F45DBc',
  ethereum: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
  logo: logos_1["default"].YFILogo
}, {
  address: '0xDDa6205Dc3f47e5280Eb726613B27374Eee9D130',
  ethereum: '0x111111111117dc0aa78b770fa6a738034120c302',
  logo: logos_1["default"].ONEINCHLogo
}, {
  address: '0x2208824Cd05Ac473D5F92D39b28F145D481669de',
  ethereum: '',
  logo: logos_1["default"].DOTLogo
}, {
  address: '0xC3C19Ee91cF3C1F7Fbf3716a09d21dC35De0bd6d',
  ethereum: '0xB8c77482e45F1F44dE1745F52C74426C631bDD52',
  logo: logos_1["default"].BNBLogo
}, {
  address: '0xD7B8710f5713D2739dA301A5ecdB8b6fFB5ec60D',
  ethereum: '',
  logo: logos_1["default"].AVAXLogo
}, {
  address: '0xd3319EAF3c4743ac75AaCE77befCFA445Ed6E69E',
  ethereum: '0xD533a949740bb3306d119CC777fa900bA034cd52',
  logo: logos_1["default"].CRVLogo
}, {
  address: '0x21a5230038C8C849d2FFb0d3ce762228Ed245237',
  ethereum: '',
  logo: logos_1["default"].LTCLogo
}, {
  address: '0xD4A161EAA78E77Eb2Af35D8E5BBDcF6af07a6835',
  ethereum: '',
  logo: logos_1["default"].BCHLogo
}, {
  address: '0x9d1a68399D14e1cf31dE846b69BA8E70b87a711F',
  ethereum: '',
  logo: logos_1["default"].DOGELogo
}, {
  address: '0x46dBd9e16c42feD902e9D35c7Bd3c9f6A3cB6321',
  ethereum: '',
  logo: logos_1["default"].CAKELogo
}, {
  address: '0xE13B07C79De28Bd34D021663744258ec456E8484',
  ethereum: '',
  logo: logos_1["default"].ADALogo
}, {
  address: '0x34f0411586d2A077499d4E11AD0CC575b06A1556',
  ethereum: '',
  logo: logos_1["default"].XRPLogo
}, {
  address: '0xC0Cd560393A3fAD67486B10BBb461eD2a42DD882',
  ethereum: '',
  logo: logos_1["default"].XLMLogo
}, {
  address: '0x132E2cd6A9bB3c53E3b0de1c4Eb005ED1BE01417',
  ethereum: '',
  logo: logos_1["default"].DASHLogo
}, {
  address: '0xb69708fFD2699FeDd7e62a4e26055A117e7369f0',
  ethereum: '',
  logo: logos_1["default"].XMRLogo
}, {
  address: '0xD821dB2439ECF24e5A623079c783E951646da449',
  ethereum: '',
  logo: logos_1["default"].ATOMLogo
}, {
  address: '0x32Aff6ADC46331dAc93E608A9CD4b0332d93a23a',
  ethereum: '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
  logo: logos_1["default"].SUSHILogo
}, {
  address: '0x32e6842a6ea6a913687885aC856c2493b5b12F6f',
  ethereum: '0x3472a5a71965499acd81997a54bba8d852c6e53d',
  logo: logos_1["default"].BADGERLogo
}, {
  address: '0x193Da10f8A969D4C081b9097B15337b1488CBbEC',
  ethereum: '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd',
  logo: logos_1["default"].LRCLogo
}, {
  address: '0x9b817C6E9a38E604606AeA3ad6ed271cE8EaA9d6',
  ethereum: '0xba100000625a3754423978a60c9317c58a424e3D',
  logo: logos_1["default"].BALLogo
}, {
  address: '0x7f3c85AB5D87f8eB8F19B545AC09a7FDd49e2B6c',
  ethereum: '',
  logo: logos_1["default"].RUNELogo
}, {
  address: '0x771513bA693D457Df3678c951c448701f2eAAad5',
  ethereum: '0xc944e90c64b2c07662a292be6244bdf05cda44a7',
  logo: logos_1["default"].GRTLogo
}, {
  address: '0xF8A425E39aF1976e1826f0C8843149AfA5e9Ec04',
  ethereum: '',
  logo: logos_1["default"].FILLogo
}, {
  address: '0xd02538b3B96564aDCf4382DCE60dfa3C26114519',
  ethereum: '',
  logo: logos_1["default"].XEMLogo
}, {
  address: '0x762204d444123BCC511718A24158A86E3D853266',
  ethereum: '0x584bc13c7d411c00c01a62e8019472de68768430',
  logo: logos_1["default"].HEGICLogo
}, {
  address: '0x881145b61c604D4d27B8969B917BC4844Cc8A9dC',
  ethereum: '',
  logo: logos_1["default"].SOLLogo
}, {
  address: '0x9419e8EdCF570a71eB0dd006602949742B711a80',
  ethereum: '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c',
  logo: logos_1["default"].BNTLogo
}, {
  address: '0x4Fec4E046E6B8dE5D22785C3FbdB104F14F5A306',
  ethereum: '0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd',
  logo: logos_1["default"].DODOLogo
}, {
  address: '0x050317d93f29D1bA5FF3EaC3b8157fD4E345588D',
  ethereum: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
  logo: logos_1["default"].MKRLogo
}, {
  address: '0x2464dD0E7eeCA2b880ECF15C7AB3A81790e0aD4C',
  ethereum: '',
  logo: logos_1["default"].NEOLogo
}, {
  address: '0xC51D97a1FD0Fd93fa16c3aEea4e42F7034D0a6EF',
  ethereum: '',
  logo: logos_1["default"].EOSLogo
}, {
  address: '0x9Bb3Ca9e1b664030cd4CF820F5b3230F2386e0c6',
  ethereum: '',
  logo: logos_1["default"].MIOTALogo
}, {
  address: '0xe854f0AA927C5244a38336548b11E903721fCa53',
  ethereum: '',
  logo: logos_1["default"].XTZLogo
}, {
  address: '0x65622f8e8b569aDE3F684B5F2a189F78F98A75b0',
  ethereum: '',
  logo: logos_1["default"].THETALogo
}, {
  address: '0x66bC411714e16B6F0C68be12bD9c666cc4576063',
  ethereum: '0xc00e94cb662c3520282e6f5717214004a7f26888',
  logo: logos_1["default"].COMPLogo
}, {
  address: '0xDc5F62055A2911F85cF16Df9f7662403387c8d46',
  ethereum: '',
  logo: logos_1["default"].TRXLogo
}, {
  address: '0xd9bAFd5e1Dd109B46207A42467be273f550FF676',
  ethereum: '0x75231f58b43240c9718dd58b4967c5114342a86c',
  logo: logos_1["default"].OKBLogo
}, {
  address: '0xdf13537f5a8c697bdeCB4870B249a1a9158b54c6',
  ethereum: '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
  logo: logos_1["default"].CROLogo
}, {
  address: '0xce6A83632aB102ff004282AE73F34AAD4C49447F',
  ethereum: '',
  logo: logos_1["default"].VETLogo
}, {
  address: '0xb2b1F16b7bB342ADCb57671f5aBa0Ae160196b75',
  ethereum: '',
  logo: logos_1["default"].LUNALogo
}, {
  address: '0xDb1895e9002d94247A5e0bA44df06d716da02f51',
  ethereum: '',
  logo: logos_1["default"].BSVLogo
}, {
  address: '0x1d2C216ee8121e6C1A20Ff9053819BeF3a64f29d',
  ethereum: '0x6f259637dcd74c767781e37bc6133cd6a68aa161',
  logo: logos_1["default"].HTLogo
}, {
  address: '0xDA79DcF81c948Dfb85CBdA738Bc898195A2Ba861',
  ethereum: '0x50D1c9771902476076eCFc8B2A83Ad6b9355a4c9',
  logo: logos_1["default"].FTTLogo
}, {
  address: '0x23f9918ee9CA163F6087aA9a8fCA1c92626F062A',
  ethereum: '',
  logo: logos_1["default"].EGLDLogo
}, {
  address: '0xdf46057212Dc0476C845fad421aAC683608458a2',
  ethereum: '',
  logo: logos_1["default"].KSMLogo
}, {
  address: '0x4bdAC5441C79de6709839dD06Ba407D5b386f2fb',
  ethereum: '',
  logo: logos_1["default"].DCRLogo
}, {
  address: '0x4778d9690cd7d9697107aEF080d5B908ABEbb83d',
  ethereum: '0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3',
  logo: logos_1["default"].LEOLogo
}, {
  address: '0x1b53c0662414B195FcD5802C09754765b930A312',
  ethereum: '0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d',
  logo: logos_1["default"].CELLogo
}, {
  address: '0xe59028425E3D3Cb0B9F71F9E18345bE517364d91',
  ethereum: '0x6eeb539d662bb971a4a01211c67cb7f65b09b802',
  logo: logos_1["default"].ZILLogo
}, {
  address: '0x7FFABDADa3ea65D32a6CCC7a1f20c0D071286535',
  ethereum: '',
  logo: logos_1["default"].STXLogo
}, {
  address: '0x6b2972207c550964E12c4d30CB87a69dc53ac0D3',
  ethereum: '',
  logo: logos_1["default"].ZECLogo
}, {
  address: '0xad3EaC6a2EF827833880a10592C6E46605E4F9d6',
  ethereum: '0x3c4b6e6e1ea3d4863700d7f76b36b7f3d3f13e3d',
  logo: logos_1["default"].VGXLogo
}, {
  address: '0xD1C63C41455afAEe16484e0896B7260CBB89e95B',
  ethereum: '',
  logo: logos_1["default"].NEARLogo
}, {
  address: '0x923E363CBa492D2c448B4bed7717f3D090851A8a',
  ethereum: '',
  logo: logos_1["default"].RVNLogo
}, {
  address: '0xEbC564e6997F11fA7606fD5a84c7082ad53abE4b',
  ethereum: '',
  logo: logos_1["default"].ETCLogo
}, {
  address: '0xaFDf614Ea3E1c0d93730f6Fc31f23BA30F17eCeA',
  ethereum: '0x4e15361fd6b4bb609fa63c81a2be19d873717870',
  logo: logos_1["default"].FTMLogo
}, {
  address: '0x04640Dc771eDd73cbeB934FB5461674830BAea11',
  ethereum: '0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206',
  logo: logos_1["default"].NEXOLogo
}, {
  address: '0x204a90B57d15417864080df1Cd6e907831c206A6',
  ethereum: '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c',
  logo: logos_1["default"].ENJLogo
}, {
  address: '0x52Af68F0Ff7452DADf8694Be0af11E52dF936Fb4',
  ethereum: '0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828',
  logo: logos_1["default"].UMALogo
}, {
  address: '0xC439E2053a97862D84FCF52629330C3e3a2D31f2',
  ethereum: '',
  logo: logos_1["default"].HBARLogo
}, {
  address: '0x5666444647f4fD66DECF411D69f994B8244EbeE3',
  ethereum: '0xba9d4199fab4f26efe3551d490e3821486f135ba',
  logo: logos_1["default"].CHSBLogo
}, {
  address: '0xB9D26bCD5a865eB0C9420C45BF0B59a77787Ff98',
  ethereum: '',
  logo: logos_1["default"].ICXLogo
}, {
  address: '0x98997E1651919fAeacEe7B96aFbB3DfD96cb6036',
  ethereum: '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
  logo: logos_1["default"].MATICLogo
}, {
  address: '0x591C19DC0821704BEDAA5Bbc6A66fee277d9437e',
  ethereum: '0xe41d2489571d322189246dafa5ebde1f4699f498',
  logo: logos_1["default"].ZRXLogo
}, {
  address: '0xe8Ba8D7765bD33BA7Ff3B19b9020C15BF14123B6',
  ethereum: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
  logo: logos_1["default"].BATLogo
}, {
  address: '0x516A98c8D473904e26Fd60dE9cb3fC4cA9869CFa',
  ethereum: '0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a',
  logo: logos_1["default"].WAVESLogo
}, {
  address: '0x83ab721c8B3Dd30AD711460f666371366550C5A7',
  ethereum: '0x408e41876cccdc0f92210600ef50372656052a38',
  logo: logos_1["default"].RENLogo
}, {
  address: '0xfe39fb0A69AcD40c3fe4FE71C813AD9F371dD28f',
  ethereum: '',
  logo: logos_1["default"].IOSTLogo
}, {
  address: '0x0883E6c6f1644BB5567865DCD5B286D92031eE20',
  ethereum: '',
  logo: logos_1["default"].ALGOLogo
}, {
  address: '0xF1BdCF2D4163adF9554111439dAbdD6f18fF9BA7',
  ethereum: '',
  logo: logos_1["default"].BTTLogo
}, {
  address: '0xD30b72eA55f9c6340B848D1A57ebBf159e7079B9',
  ethereum: '',
  logo: logos_1["default"].ONTLogo
}, {
  address: '0xAD7ABE6f12F1059bDf48aE67bfF92B00438ceD95',
  ethereum: '',
  logo: logos_1["default"].AMPLogo
}, {
  address: '0xC424de9851dFAFB5d30b7Ec034EB00c22e1B537c',
  ethereum: '',
  logo: logos_1["default"].DGBLogo
}, {
  address: '0x5cB7423aEd7173eE3209408E0963f4600a7A05cd',
  ethereum: '',
  logo: logos_1["default"].NANOLogo
}, {
  address: '0xC4eFAd8386124927Fb46b146526625e143e5a63A',
  ethereum: '0xe4815ae53b124e7263f08dcdbbb757d41ed658c6',
  logo: logos_1["default"].ZKSLogo
}, {
  address: '0x81888a2B486670f70c2c5F8e394519939da01524',
  ethereum: '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07',
  logo: logos_1["default"].OMGLogo
}, {
  address: '0xaFB4942F45a01c67C83d969EA83129926e05f6Fe',
  ethereum: '',
  logo: logos_1["default"].QTUMLogo
}, {
  address: '0x70ADA65dE12E5c0F6ff7E58Cad734a813cA50bf3',
  ethereum: '',
  logo: logos_1["default"].ARLogo
}, {
  address: '0x78C6efEB603e48C6F64EddEC7131FcA4915E2014',
  ethereum: '',
  logo: logos_1["default"].MDXLogo
}, {
  address: '0xa82fc24687fFbDe40776DeDe7C70F845b67f3EF7',
  ethereum: '0x3506424f91fd33084466f402d5d97f05f8e3b4af',
  logo: logos_1["default"].CHZLogo
}, {
  address: '0x34b97EEaB6FD9BBe95A5eAF4645307c5a6f3D4d0',
  ethereum: '0x6c6ee5e31d828de241282b9606c8e98ea48526e2',
  logo: logos_1["default"].HOTLogo
}, {
  address: '0xfcE13BB63B60f6e20ed846ae73ed242D29129800',
  ethereum: '0x8762db106b2c2a0bccb3a80d1ed41273552616e8',
  logo: logos_1["default"].RSRLogo
}, {
  address: '0x387005F39bF464c00bF3aC7C80021f919c2F4164',
  ethereum: '',
  logo: logos_1["default"].EWTLogo
}, {
  address: '0x59aB18fE5990E45e5E508930eEF3369DB7A422f5',
  ethereum: '',
  logo: logos_1["default"].SCLogo
}, {
  address: '0xE469960B138abBfD4c82147393e955C537bB6b54',
  ethereum: '0x0f5d2fb29fb7d3cfee444a200298f468908cc942',
  logo: logos_1["default"].MANALogo
}, {
  address: '0x99A17fB61fBDc4E42F6b0f496fe92Ba820CE5d2b',
  ethereum: '0x967da4048cd07ab37855c090aaf366e4ce1b9f48',
  logo: logos_1["default"].OCEANLogo
}, {
  address: '0x05B357201B31093A13a22d76dE1b1eb23aD83017',
  ethereum: '0xa1faa113cbe53436df28ff0aee54275c13b40975',
  logo: logos_1["default"].ALPHALogo
}, {
  address: '0x1bf6eA422574E0F5d336083a771768Cb4e11390d',
  ethereum: '',
  logo: logos_1["default"].NPXSLogo
}, {
  address: '0x8dbAD759014B0AA140ECd7AEd0e052b4F5C63bE1',
  ethereum: '0xdd974d5c2e2928dea5f71b9825b8b646686bd200',
  logo: logos_1["default"].KNCLogo
}, {
  address: '0x2C969B248144dC371b428705Da84b413203d9e76',
  ethereum: '0xfe3e6a25e6b192a42a44ecddcd13796471735acf',
  logo: logos_1["default"].REEFLogo
}, {
  address: '0xf4D3AC1322BaE5B0b7b49b4C582941131c5e0A82',
  ethereum: '',
  logo: logos_1["default"].LSKLogo
}, {
  address: '0x462B35452E552A66B519EcF70aEdb1835d434965',
  ethereum: '0x4a220e6096b25eadb88358cb44068a3248254675',
  logo: logos_1["default"].QNTLogo
}, {
  address: '0xD83EDa5A201532291c1fB71e6E3471b8EF3575aC',
  ethereum: '0xd7c49cee7e9188cca6ad8ff264c1da2e69d4cf3b',
  logo: logos_1["default"].NXMLogo
}, {
  address: '0xe2b7ed0b29C445F701b5954D71463beB8A77c085',
  ethereum: '',
  logo: logos_1["default"].ZENLogo
}, {
  address: '0x35eF8875672b072e38e87Ebe22A0aa3965534584',
  ethereum: '',
  logo: logos_1["default"].CELOLogo
}, {
  address: '0x6bb14afEdC740dCE4904B7a65807fE3b967f4c94',
  ethereum: '0x744d70fdbe2ba4cf95131626614a1763df805b9e',
  logo: logos_1["default"].SNTLogo
}, {
  address: '0xD001188ee1830425fD2B0Fb21f6F3bB79BaB161E',
  ethereum: '',
  logo: logos_1["default"].ONELogo
}, {
  address: '0x77f38fAB153FDb599c5983533df0c894C2B7DD76',
  ethereum: '',
  logo: logos_1["default"].HNTLogo
}, {
  address: '0xC61382eC7C236211207575cB75410546da98be17',
  ethereum: '',
  logo: logos_1["default"].CKBLogo
}, {
  address: '0x241eBDFDfbED02c6e727562777C902E54eEE53c3',
  ethereum: '',
  logo: logos_1["default"].KAVALogo
}, {
  address: '0xE8d81BD45c9cB01813031F66ABe10bd3de3551Bb',
  ethereum: '',
  logo: logos_1["default"].ARDRLogo
}, {
  address: '0x2b02cd785e30a6831d41027449FB58CA62Ba157F',
  ethereum: '',
  logo: logos_1["default"].ARKLogo
}, {
  address: '0x827c3f7FFa144598144F1E10ec9E157B5a0ABA18',
  ethereum: '0x2b89bf8ba858cd2fcee1fada378d5cd6936968be',
  logo: logos_1["default"].SCRTLogo
}, {
  address: '0x12490d720747E312bE64029Dfd475837Ed285cFe',
  ethereum: '',
  logo: logos_1["default"].SFPLogo
}, {
  address: '0x0AfE3ff501cF4a7f6dD510D32d90e4D8aC963ABD',
  ethereum: '',
  logo: logos_1["default"].RIFLogo
}, {
  address: '0xbb73A680B1A1085Bed5B41f6077F692ae04EF6a8',
  ethereum: '',
  logo: logos_1["default"].ROSELogo
}, {
  address: '0xFAA02b262130431B44c929fDd960e202fFEABfE3',
  ethereum: '',
  logo: logos_1["default"].TWTLogo
}, {
  address: '0x13cA6f2ec4045Dae6E052268e12d0D3d2Cea0bf9',
  ethereum: '',
  logo: logos_1["default"].KMDLogo
}, {
  address: '0x18Cd49ABDAf652EAB2C802608CD63F9505a15bC0',
  ethereum: '',
  logo: logos_1["default"].STEEMLogo
}, {
  address: '0x3e85A2A0Da09780208A5a3bf6C371bF752175a97',
  ethereum: '',
  logo: logos_1["default"].TOMOLogo
}, {
  address: '0xf3ff3bF1d1afCbeBD98A304482c4099Dc953E9a8',
  ethereum: '0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429',
  logo: logos_1["default"].GLMLogo
}, {
  address: '0x5E2D55bC07B63b18Af6C9ED8Da06CD33258ebb35',
  ethereum: '0x0258f474786ddfd37abce6df6bbb1dd5dfc4434a',
  logo: logos_1["default"].ORNLogo
}, {
  address: '0x79786Ed8a70ccEC6C7A31debC7FeFc5119f9dc95',
  ethereum: '0xff20817765cb7f73d4bde2e66e067e58d11095c2',
  logo: logos_1["default"].AMPLLogo
}, {
  address: '0xE99BBD3b25A014Aac93127Cf868d3De07386c4DD',
  ethereum: '0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec',
  logo: logos_1["default"].POLYLogo
}, {
  address: '0xb2Ef65460BF71a05d59FDf5e8F114A32d445D164',
  ethereum: '0xba11d00c5f74255f56a5e366f4f77f5a186d7f55',
  logo: logos_1["default"].BANDLogo
}, {
  address: '0x324A1e5707F356218356C95cFe20D5D9b1440f30',
  ethereum: '0xcc4304a31d09258b0029ea7fe63d032f52e44efe',
  logo: logos_1["default"].SWAPLogo
}, {
  address: '0xDb045876525A707f4E150D3D64868E50893a79ba',
  ethereum: '0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa',
  logo: logos_1["default"].POLSLogo
}, {
  address: '0x73a4AC88c12D66AD08c1cfC891bF47883919ba74',
  ethereum: '0x3845badAde8e6dFF049820680d1F14bD3903a5d0',
  logo: logos_1["default"].SANDLogo
}, {
  address: '0x44F26117E6c7f6Aa4Ba8C9F068246f973423bcd0',
  ethereum: '0x4fe83213d56308330ec302a8bd641f1d0113a4cc',
  logo: logos_1["default"].NULogo
}, {
  address: '0x7E58CeF7C589E0e1771B9c049cBa313fDEc31976',
  ethereum: '',
  logo: logos_1["default"].MIRLogo
}, {
  address: '0x09319044A98e6Bb4D95a6C112789AFcEBE5B58AC',
  ethereum: '0xb753428af26e81097e7fd17f40c88aaa3e04902c',
  logo: logos_1["default"].SFILogo
}, {
  address: '0xF452bff8e958C6F335F06fC3aAc427Ee195366fE',
  ethereum: '0x6810e776880c02933d47db1b9fc05908e5386b96',
  logo: logos_1["default"].GNOLogo
}, {
  address: '0xa34146187bF01B368017ab3555D1078380aaDB4b',
  ethereum: '0xddb3422497e61e13543bea06989c0789117555c5',
  logo: logos_1["default"].COTILogo
}, {
  address: '0xaAD4Add9b6ED577f3fe9E6bccbbe3bDCe596b062',
  ethereum: '0xa1d6df714f91debf4e0802a542e13067f31b8262',
  logo: logos_1["default"].RFOXLogo
}, {
  address: '0x04cd06cf05b816F09395375f0143584B4A95eA9f',
  ethereum: '0x419d0d8bdd9af5e606ae2232ed285aff190e711b',
  logo: logos_1["default"].FUNLogo
}, {
  address: '0x4B3686EEc98b2b89102F2830003097C7D4e1f691',
  ethereum: '0xa117000000f279d81a1d3cc75430faa017fa5a2e',
  logo: logos_1["default"].ANTLogo
}, {
  address: '0x2A2666F62157769D09A64488Bbb51bD77036F6CE',
  ethereum: '0x221657776846890989a759BA2973e427DfF5C9bB',
  logo: logos_1["default"].REPLogo
}, {
  address: '0x746514E2c7D91E1e84C20c54d1F6F537b28A7d8e',
  ethereum: '0x69af81e73a73b40adf4f3d4223cd9b1ece623074',
  logo: logos_1["default"].MASKLogo
}, {
  address: '0xab1078F4c4d949a176a6Ebcabe50C723aBf1fdb8',
  ethereum: '0xe28b3b32b6c345a34ff64674606124dd5aceca30',
  logo: logos_1["default"].INJLogo
}, {
  address: '0xE3D7a5C28d5a4143831242E8ab218D7e9B5c2c87',
  ethereum: '0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e',
  logo: logos_1["default"].UBTLogo
}, {
  address: '0x0d91d554768dC20E1D3D95FF9d5bC041edC3bA0f',
  ethereum: '0x41e5560054824ea6b0732e656e3ad64e20e94e45',
  logo: logos_1["default"].CVCLogo
}, {
  address: '0x83AF4137Ed450F4765A72831Dd938B5203f5d2Fb',
  ethereum: '0x476c5e26a75bd202a9683ffd34359c0cc15be0ff',
  logo: logos_1["default"].SRMLogo
}, {
  address: '0x456b1366783D0F5FBf0bBb89E7c9476AB328Db84',
  ethereum: '0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4',
  logo: logos_1["default"].ANKRLogo
}, {
  address: '0xd72922E849477a042a7E6DC84309F4bC1C1227A2',
  ethereum: '0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671',
  logo: logos_1["default"].NMRLogo
}, {
  address: '0xA2f452358CA632be20BAd0a60dE51d3F0fd59910',
  ethereum: '0x0AbdAce70D3790235af448C88547603b945604ea',
  logo: logos_1["default"].DNTLogo
}, {
  address: '0x4fffe0168b04f039496ca5189f9596c22693A19c',
  ethereum: '',
  logo: logos_1["default"].IOTXLogo
}, {
  address: '0x3A5B18733c8807508138b0Fa74eb612b9E70F001',
  ethereum: '',
  logo: logos_1["default"].BTSLogo
}, {
  address: '0x2A7ed4A3e15f036d86a28271BEe580D8682A1eea',
  ethereum: '',
  logo: logos_1["default"].SYSLogo
}, {
  address: '0x1e3EEd9c1eba5e5114D4c185DC71d13c3C66dd84',
  ethereum: '0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26',
  logo: logos_1["default"].OGNLogo
}, {
  address: '0xee15d16a31F24b8c4e249D75878b3F6d4086Ad2e',
  ethereum: '',
  logo: logos_1["default"].AVALogo
}, {
  address: '0x202317a4046fF991B97F9278D5988993DF5ED26e',
  ethereum: '',
  logo: logos_1["default"].NXSLogo
}, {
  address: '0x96717283E442FfCE9b636f004C196517a72eE4cA',
  ethereum: '',
  logo: logos_1["default"].AIONLogo
}, {
  address: '0x05D1C70c98f0Bc85001CA36dE589397243754e33',
  ethereum: '',
  logo: logos_1["default"].HARDLogo
}, {
  address: '0xa5526097203C4C3a9d8bD5810ff0A7C9AECE58C4',
  ethereum: '0x88dF592F8eb5D7Bd38bFeF7dEb0fBc02cf3778a0',
  logo: logos_1["default"].TRBLogo
}, {
  address: '0xb8dF08566f48b25C8b960e829BAdf79a4740dDc2',
  ethereum: '',
  logo: logos_1["default"].CTKLogo
}, {
  address: '0x81639e65b88873675Ae76427537Ba3BCA4c7d1f0',
  ethereum: '',
  logo: logos_1["default"].WANLogo
}, {
  address: '0x1833e138fadf220Eb951A8590B8BA9058785DDDe',
  ethereum: '0x4F9254C83EB525f9FCf346490bbb3ed28a81C667',
  logo: logos_1["default"].CELRLogo
}, {
  address: '0xAf86Af19fE816afa951596be5E379C7d728622D8',
  ethereum: '0x42476F744292107e34519F9c357927074Ea3F75D',
  logo: logos_1["default"].LOOMLogo
}, {
  address: '0x1a4d26bD3E3Eaf582aC47E7B566A915e52d2Adf5',
  ethereum: '',
  logo: logos_1["default"].HIVELogo
}, {
  address: '0x02C6c53930B20BCEd86Ddf64007BEBcd923e1093',
  ethereum: '0xEA26c4aC16D4a5A106820BC8AEE85fd0b7b2b664',
  logo: logos_1["default"].QKCLogo
}, {
  address: '0x12357548161Df5fA9BD5E9313A405Cd161d46C35',
  ethereum: '0x8Ab7404063Ec4DBcfd4598215992DC3F8EC853d7',
  logo: logos_1["default"].AKROLogo
}, {
  address: '0x2483a716A4A5476da5E657be13A37Cf62b608AB6',
  ethereum: '0xd4fa1460f537bb9085d22c7bccb5dd450ef28e3a',
  logo: logos_1["default"].PPTLogo
}, {
  address: '0xcDe71daaFFB6a12d584f55777D4c9e9D3c353c1E',
  ethereum: '0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac',
  logo: logos_1["default"].STORJLogo
}, {
  address: '0x2C25972d4AdB478773bE354a09E4596f29E31fb3',
  ethereum: '0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998',
  logo: logos_1["default"].AUDIOLogo
}, {
  address: '0x117fe461FFCF40C2a5A6d95FFC7FE151d243bAD2',
  ethereum: '0x940a2dB1B7008B6C776d4faaCa729d6d4A4AA551',
  logo: logos_1["default"].DUSKLogo
}, {
  address: '0xba71E0c0b13E724bF2329eCb9BdF5775a2Ce9e8d',
  ethereum: '0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83',
  logo: logos_1["default"].YFIILogo
}, {
  address: '0x5d6b480d7B11656BA575E5883Dce50809C619732',
  ethereum: '0x2ba592F78dB6436527729929AAf6c908497cB200',
  logo: logos_1["default"].CREAMLogo
}, {
  address: '0xD2D28530A79634423154c1FD5BDb7C1B0216cD1A',
  ethereum: '0xf433089366899d83a9f26a773d59ec7ecf30355e',
  logo: logos_1["default"].MTLLogo
}, {
  address: '0x4Bd75f8c7E067Ea9B6E2DFBECd99d805396bC5FF',
  ethereum: '0x3F382DbD960E3a9bbCeaE22651E88158d2791550',
  logo: logos_1["default"].GHSTLogo
}, {
  address: '0x0894840ba7d57c7Adf2cAf8fd3c41Eb79AF5B8e7',
  ethereum: '',
  logo: logos_1["default"].WRXLogo
}, {
  address: '0x3FA2C976654A6BA6DCb1e532a4B1E31Fd4DCd3b9',
  ethereum: '0x5732046A883704404F284Ce41FfADd5b007FD668',
  logo: logos_1["default"].BLZLogo
}, {
  address: '0x81d9458b4e2ec614e7FCFC303D331F33d986F9BE',
  ethereum: '0xDF2C7238198Ad8B389666574f2d8bc411A4b7428',
  logo: logos_1["default"].MFTLogo
}, {
  address: '0xF2176b1089c92FC0631bACBB36DD9F604f698b4E',
  ethereum: '0xfA5047c9c78B8877af97BDcb85Db743fD7313d4a',
  logo: logos_1["default"].ROOKLogo
}, {
  address: '0xF4BB0ED25Ac7bcc9c327B88BaC5CA288A08eC41e',
  ethereum: '0xD291E7a03283640FDc51b121aC401383A46cC623',
  logo: logos_1["default"].RGTLogo
}, {
  address: '0x86670E263ef2bE4E1110A08AE418483b07f2544b',
  ethereum: '0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC',
  logo: logos_1["default"].KEEPLogo
}, {
  address: '0xD1BBC2A68B97A8aE4b423BbF534e767Ef6275a30',
  ethereum: '0x595832f8fc6bf59c85c527fec3740a1b7a361269',
  logo: logos_1["default"].POWRLogo
}, {
  address: '0xda319365F512B165Df8827365AF680550e98058F',
  ethereum: '0xbC396689893D065F41bc2C6EcbeE5e0085233447',
  logo: logos_1["default"].PERPLogo
}, {
  address: '0xbF8afa4663B30c621a5f7497a972Fc63c1a06c66',
  ethereum: '0x45804880De22913dAFE09f4980848ECE6EcbAf78',
  logo: logos_1["default"].PAXGLogo
}, {
  address: '0xCF0a240Ce14d80287C993611419A4AeFAe269Ef3',
  ethereum: '0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b',
  logo: logos_1["default"].DPILogo
}, {
  address: '0xf7a1d806dA81242319Cfd6407a49a39b5517C877',
  ethereum: '0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55',
  logo: logos_1["default"].SUPERLogo
}, {
  address: '0xA55b5de8598e8A2E313CD17ec5e2eDf2811Ce0D9',
  ethereum: '0xa0246c9032bC3A600820415aE600c6388619A14D',
  logo: logos_1["default"].FARMLogo
}, {
  address: '0xB4Ff17b5e93C40ff09326B0d538118022F02dc2b',
  ethereum: '0x607f4c5bb672230e8672085532f7e901544a7375',
  logo: logos_1["default"].RLCLogo
}, {
  address: '0xB9acFE14eF575Cb043Ffde23922c2bf97651a207',
  ethereum: '0x0Ae055097C6d159879521C384F1D2123D1f195e6',
  logo: logos_1["default"].STAKELogo
}, {
  address: '0xd9dd4B6764946B354CBFc85F5C1C6fF7BccB01e3',
  ethereum: '0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF',
  logo: logos_1["default"].RARILogo
}, {
  address: '0xf25Ef66291CC2469781Fa18512d6b26431CB0747',
  ethereum: '0x4bD70556ae3F8a6eC6C4080A0C327B24325438f3',
  logo: logos_1["default"].HXROLogo
}, {
  address: '0x0702bf2aBBB53f8fEB101A71199965b891dbAE97',
  ethereum: '0x2b915b505c017abb1547aa5ab355fbe69865cc6d',
  logo: logos_1["default"].MAPSLogo
}, {
  address: '0xEe0837E18F64EC6cf3bECe2dA75a1e5f679A6D84',
  ethereum: '0xe5caef4af8780e59df925470b050fb23c43ca68c',
  logo: logos_1["default"].FRMLogo
}, {
  address: '0xc0C36bab186BE1a2dbaF01B73CcBAAF8cF5A467E',
  ethereum: '0x431ad2ff6a9C365805eBaD47Ee021148d6f7DBe0',
  logo: logos_1["default"].DFLogo
}, {
  address: '0x3e44694d00835cB8187CA32828C8Bd7480778048',
  ethereum: '0x56d811088235F11C8920698a204A5010a788f4b3',
  logo: logos_1["default"].BZRXLogo
}, {
  address: '0x09F24E5E54dB6705df1a1a71D2Bd5eAC0d692beA',
  ethereum: '0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44',
  logo: logos_1["default"].KP3RLogo
}, {
  address: '0x723E54fB61BEeC583B3a5cE80a4484CF5E816F99',
  ethereum: '0x374CB8C27130E2c9E04F44303f3c8351B9De61C1',
  logo: logos_1["default"].BAOLogo
}, {
  address: '0x003d765F3793DE38AD5eA9D5FD0021cF12C3bA68',
  ethereum: '0x04969cd041c0cafb6ac462bd65b536a5bdb3a670',
  logo: logos_1["default"].OMILogo
}, {
  address: '0x7fDb933327aa6989ae706001c2EA54BA5E046e79',
  ethereum: '0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce',
  logo: logos_1["default"].SHIBLogo
}, {
  address: '0xA4ECF6D10B8D61D4A022821A6FF8b9536a47c70D',
  ethereum: '0x767fe9edc9e0df98e07454847909b5e959d7ca0e',
  logo: logos_1["default"].ILVLogo
}, {
  address: '0x7CD3D51beE45434Dd80822c5D58b999333b69FfB',
  ethereum: '0xbb0e17ef65f82ab018d8edd776e8dd940327b28b',
  logo: logos_1["default"].AXSLogo
}, {
  address: '0xFFD7510ca0a3279c7a5F50018A26c21d5bc1DBcF',
  ethereum: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  logo: logos_1["default"].USDCLogo
}, {
  address: '0x9ffBE4f6416A7FB51f233966562B6b0DC3fE6B9B',
  ethereum: '0x090185f2135308bad17527004364ebcc2d37e5f6',
  logo: logos_1["default"].SPELLLogo
}, {
  address: '0xb7AE81B04584fA27572A73Abc599104D7DA42f02',
  ethereum: '0x6399c842dd2be3de30bf99bc7d1bbf6fa3650e70',
  logo: logos_1["default"].PREMIALogo
}, {
  address: '0xFA8710C6fcd9D1357b06D92d67349741626dB312',
  ethereum: '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3',
  logo: logos_1["default"].ELONLogo
}, {
  address: '0xa598B856fA2d5e016d2E84a6a86Ff99D69dD841E',
  ethereum: '0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25',
  logo: logos_1["default"].SLPLogo
}, {
  address: '0x0F46Fe95a8d6573990118AEE8b7AC9A3532f5963',
  ethereum: '',
  logo: logos_1["default"].USDELogo
}];
var mergedTokens = mainnetTokens.map(function (token) {
  return __assign(__assign({}, token), tokens_json_1["default"].mainnet.find(function (fetchedTokens) {
    return fetchedTokens.address.toLowerCase() === token.address.toLowerCase();
  }));
});
exports["default"] = mergedTokens;